export default {
  path: '/ratio-order',
  meta: {
    title: '我的订单',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/ratio-order`),
}



// WEBPACK FOOTER //
// ./src/views/RatioOrder/router.js